/**
 * Author: Cascade using Claude Sonnet 4.5
 * Date: 2025-10-10T10:04:10-04:00
 * PURPOSE: Central mapping of ARC puzzle IDs to their friendly names.
 * Extracted from PuzzleNamesExtracted.md to provide a single source of truth.
 * Used across frontend and backend to display human-readable puzzle names.
 * 
 * SRP/DRY check: Pass - Single responsibility for puzzle name lookup, prevents duplication
 * shadcn/ui: N/A - Utility file, no UI components
 */

/**
 * Comprehensive mapping of ARC puzzle IDs to their friendly names.
 * Source: docs/PuzzleNamesExtracted.md
 */
export const PUZZLE_NAMES: Record<string, string> = {
  '007bbfb7': 'fractal',
  '00d62c1b': 'honeypots',
  '017c7c7b': 'beanstalk',
  '025d127b': 'tilt',
  '045e512c': 'stamp',
  '0520fde7': 'intersect',
  '05269061': 'diagstripes',
  '05f2a901': 'magnets',
  '06df4c85': 'gridlines',
  '08ed6ac7': 'barchart',
  '09629e4f': 'four',
  '0962bcdd': 'supernova',
  '0a938d79': 'columns',
  '0b148d64': 'minstatic',
  '0ca9ddb6': 'twinkle',
  '0d3d703e': 'complement',
  '0dfd9992': 'cutouts',
  '0e206a2e': 'clones',
  '10fcaaa3': 'quadcopter',
  '11852cab': 'checkered',
  '1190e5a7': 'groupby',
  '137eaa0f': 'shatter',
  '150deff5': 'tinkertoys',
  '178fcbfb': 'rgb',
  '1a07d186': 'cling',
  '1b2d62fb': 'seethru',
  '1b60fb0c': 'regrow',
  '1bfc4729': 'frame',
  '1c786137': 'crop',
  '1caeab9d': 'valign',
  '1cf80156': 'animals',
  '1e0a9b12': 'gravity',
  '1e32b0e9': 'mostest',
  '1f0c79e5': 'sprout',
  '1f85a75f': 'sprinkles',
  '1f876c06': 'celestial',
  '1fad071e': 'diags',
  '2013d3e2': 'pinwheel',
  '2204b7a8': 'classify',
  '22168020': 'antennafill',
  '22233c11': 'kittycorner',
  '2281f1f4': 'intersect',
  '228f6490': 'putthemback',
  '22eb0ac0': 'match',
  '234bbc79': 'stitch',
  '23581191': 'rooks',
  '239be575': 'pathexists',
  '23b5c85d': 'smallestrect',
  '253bf280': 'lightsabers',
  '25d487eb': 'laser',
  '25d8a9c8': 'solid',
  '25ff71a9': 'scooch',
  '264363fd': 'flagmaker',
  '272f95fa': 'fill',
  '27a28665': 'oneof',
  '28bf18c6': 'doublevision',
  '28e73c20': 'spiral',
  '29623171': 'argmax',
  '29c11459': 'twotone',
  '29ec7d0e': 'cutouts2',
  '2bcee788': 'greenbelt',
  '2bee17df': 'fringes',
  '2c608aff': 'beamdown',
  '2dc579da': 'oddoneout',
  '2dd70a9a': 'ricochet',
  '2dee498d': 'first',
  '31aa019c': 'onlyone',
  '321b1fc6': 'cutandpaste',
  '32597951': 'screendoor',
  '3345333e': 'occlusion',
  '3428a4f5': 'xor',
  '3618c87e': 'towers',
  '3631a71a': 'kaleidoscope',
  '363442ee': 'copypaste',
  '36d67576': 'rainbowsprite',
  '36fdfd69': 'underneath',
  '3906de3d': 'slots',
  '39a8645d': 'maxconway',
  '39e1d7f9': 'gridlines2',
  '3aa6fb7a': 'blueboxes',
  '3ac3eb23': 'lattice',
  '3af2c5a8': 'unfold',
  '3bd67248': 'ketchup',
  '3bdb4ada': 'punchcards',
  '3befdf3e': 'anthesis',
  '3c9b0459': 'rotate',
  '3de23699': 'invertandzoom',
  '3e980e27': 'spritefulsky',
  '3eda0437': 'biggestgap',
  '3f7978a0': 'glowsticks',
  '40853293': 'sticks',
  '4093f84a': 'precipitate',
  '41e4d17e': 'crosshairs',
  '4258a5f9': 'shield',
  '4290ef0e': 'bullseye',
  '42a50994': 'nofriends',
  '4347f46a': 'hollowedout',
  '444801d8': 'burst',
  '445eab21': 'bigger',
  '447fd412': 'similarshape',
  '44d8ac46': 'squareornot',
  '44f52bb0': 'issymmetric',
  '4522001f': 'pimento',
  '4612dd53': 'dottedboxes',
  '46442a0e': 'quadruple',
  '469497ad': 'enhancediag',
  '46f33fce': 'waterbeads',
  '47c1f68c': 'copyfour',
  '484b58aa': 'cutouts3',
  '48d8fb45': 'selector',
  '4938f0c2': 'mistletoe',
  '496994bd': 'reflection',
  '49d1d64f': 'grow',
  '4be741c5': 'wetpaint',
  '4c4377d9': 'colorfoldup',
  '4c5c2cf0': 'crablegs',
  '50846271': 'underneath2',
  '508bd3b6': 'rebound',
  '50cb2852': 'cremefilled',
  '5117e062': 'cyanconway',
  '5168d44c': 'increment',
  '539a4f51': 'coping',
  '53b68214': 'extenddown',
  '543a7ed5': 'nestedrects',
  '54d82841': 'shooter',
  '54d9e175': 'xmaslights',
  '5521c0d9': 'jump',
  '5582e5ca': 'mode',
  '5614dbcf': 'destatic',
  '56dc2b01': 'compressor',
  '56ff96f3': 'corners',
  '57aa92db': 'scaledregrow',
  '5ad4f10b': 'megaconway',
  '5bd6f4ac': 'topright',
  '5c0a986e': 'captureflag',
  '5c2c9af4': 'radar',
  '5daaa586': 'colorfall',
  '60b61512': 'refill',
  '6150a2bd': 'invxpose',
  '623ea044': 'bishop',
  '62c24649': 'unfold2',
  '63613498': 'graythematch',
  '6430c8c4': 'voids',
  '6455b5f5': 'bisection',
  '662c240a': 'asymmetric',
  '67385a82': 'components',
  '673ef223': 'portals',
  '6773b310': 'two',
  '67a3c6ac': 'flip',
  '67a423a3': 'buckle',
  '67e8384a': 'unfold3',
  '681b3aeb': 'recombine',
  '6855a6e4': 'assemble',
  '68b16354': 'flipinplace',
  '694f12f3': 'mixedberry',
  '6a1e5592': 'footprints',
  '6aa20dc0': 'copyandzoom',
  '6b9890af': 'conwaybox',
  '6c434453': 'boxtoplus',
  '6cdd2623': 'rowandcolumn',
  '6cf79266': 'bluesquare',
  '6d0160f0': 'unoamarillo',
  '6d0aefbc': 'fliphoriz',
  '6d58a25d': 'kites',
  '6d75e8bb': 'velcro',
  '6e02f1e3': 'numcolors',
  '6e19193c': 'arrows',
  '6e82a1ae': 'twothreefour',
  '6ecd11f4': 'hybridsprite',
  '6f8cd79b': 'border',
  '6fa7a44f': 'flipvert',
  '72322fa7': 'splitsprites',
  '72ca375d': 'symmetricone',
  '73251a56': 'cutouts4',
  '7447852a': 'hotdog',
  '7468f01a': 'flipandzoom',
  '746b3537': 'layercake',
  '74dd1130': 'xpose',
  '75b8110e': 'layers',
  '760b3cac': 'biflector',
  '776ffc46': 'matchbox',
  '77fdfe62': 'cornercolor',
  '780d0b14': 'dirtyquilt',
  '7837ac64': 'needlepoint',
  '794b24be': 'count',
  '7b6016b9': 'linedboxes',
  '7b7f7511': 'half',
  '7c008303': 'cornercolor2',
  '7ddcd7ec': 'webslinger',
  '7df24a62': 'patternmatch',
  '7e0986d6': 'destatic2',
  '7f4411dc': 'samestatic',
  '7fe24cdd': 'pinwheel2',
  '80af3007': 'graysprite',
  '810b9b61': 'closedloop',
  '82819916': 'autocomplete',
  '83302e8f': 'permeation',
  '834ec97d': 'yellowstripe',
  '8403a5d5': 'snake',
  '846bdb03': 'installation',
  '855e0971': 'strata',
  '85c4e7cd': 'framereverse',
  '868de0fa': 'autumnboxes',
  '8731374e': 'confettibox',
  '88a10436': 'copypaste2',
  '88a62173': 'onediff',
  '890034e9': 'findcutouts',
  '8a004b2b': 'copymagnify',
  '8be77c9e': 'centerfold',
  '8d5021e8': 'sixfold',
  '8d510a79': 'groundsky',
  '8e1813be': 'horizstripes',
  '8e5a5113': 'rollingstone',
  '8eb1be9a': 'pattern',
  '8efcae92': 'mostpixels',
  '8f2ea7aa': 'fractal2',
  '90c28cc7': 'cleanquilt',
  '90f3ed37': 'extendblue',
  '913fb3ed': 'candyshells',
  '91413438': 'lessismore',
  '91714a58': 'justthebox',
  '9172f3a0': 'enhance',
  '928ad970': 'boxinabox',
  '93b581b8': 'bloom',
  '941d9a10': 'blueredgreen',
  '94f9d214': 'voids2',
  '952a094c': 'framereverse',
  '9565186b': 'maxonly',
  '95990924': 'quadlights',
  '963e52fc': 'extendright',
  '97999447': 'graysnakes',
  '97a05b5b': 'perfection',
  '98cf29f8': 'frogandfly',
  '995c5fa3': 'iou',
  '99b1bc43': 'xor2',
  '99fa7670': 'overanddown',
  '9aec4887': 'assimilate',
  '9af7a82c': 'unroll',
  '9d9215db': 'dottedsquare',
  '9dfd6313': 'flipdiag',
  '9ecd008a': 'blackcutout',
  '9edfc990': 'porosity',
  '9f236235': 'dehanceflip',
  'a1570a43': 'recenter',
  'a2fd1cf0': 'hpwl',
  'a3325580': 'manymax',
  'a3df8b1e': 'bounce',
  'a416b8f3': 'clone',
  'a48eeaf7': 'staticcling',
  'a5313dff': 'targets',
  'a5f85a15': 'evenodd',
  'a61ba2ce': 'reassemble',
  'a61f2674': 'minimax',
  'a64e4611': 'excavation',
  'a65b410d': 'grb',
  'a68b268e': 'layers2',
  'a699fb00': 'redblue',
  'a740d043': 'zoomnoblue',
  'a78176bb': 'stairways',
  'a79310a0': 'redshift',
  'a85d4709': 'stoplight',
  'a87f7484': 'theweirdone',
  'a8c38be5': 'ninebynine',
  'a8d7556c': 'gapfiller',
  'a9f96cdd': 'petalsonly',
  'aabf363d': 'recolor',
  'aba27056': 'fountain',
  'ac0a08a4': 'enhance2',
  'ae3edfdc': 'unexplode',
  'ae4f1146': 'bluemax',
  'aedd82e4': 'edgefree',
  'af902bf9': 'magmacore',
  'b0c4d837': 'halffull',
  'b190f7f5': 'colorcopies',
  'b1948b0a': 'redeye',
  'b230c067': 'biggerisblue',
  'b27ca6d3': 'olives',
  'b2862040': 'openorclosed',
  'b527c5c6': 'lasereyes',
  'b548a754': 'envelop',
  'b60334d2': 'lifesavers',
  'b6afb2da': 'luxobox',
  'b7249182': 'twotone2',
  'b775ac94': 'missinglegs',
  'b782dc8a': 'maizerouter',
  'b8825c91': 'duocutout',
  'b8cdaf2b': 'antenna',
  'b91ae062': 'enhance3',
  'b94a9452': 'zoominvert',
  'b9b7f026': 'findthedonut',
  'ba26e723': 'centipede',
  'ba97ae07': 'sendtoback',
  'bb43febb': 'jellyfilled',
  'bbc9ae5d': 'stairs',
  'bc1d5164': 'foldin',
  'bd4472b8': 'xerox',
  'bda2d7a6': 'crusher',
  'bdad9b1f': 'crossroads',
  'be94b721': 'biggestone',
  'beb8660c': 'sorted',
  'c0f76784': 'threesquares',
  'c1d99e64': 'straightaway',
  'c3e719e8': 'maxfractal',
  'c3f564a4': 'holeystripes',
  'c444b776': 'quadrantdust',
  'c59eb873': 'enhance4',
  'c8cbb738': 'brokenborder',
  'c8f0f002': 'grayshift',
  'c909285e': 'wafercut',
  'c9e6f938': 'bitflip',
  'c9f8e694': 'painters',
  'caa06a1f': 'checkerboard',
  'cbded52d': 'connectthree',
  'cce03e0d': 'copyred',
  'cdecee7f': 'permutation',
  'ce22a75a': 'inflate',
  'ce4f8723': 'greenmerge',
  'ce602527': 'partialzoom',
  'ce9e57f2': 'floordivide',
  'cf98881b': 'layers3',
  'd037b0a7': 'waterfall',
  'd06dbe63': 'squiggle',
  'd07ae81c': 'cutacross',
  'd0f5fe59': 'countsprites',
  'd10ecb37': 'topleft',
  'd13f3404': 'crash',
  'd22278a0': 'ripples',
  'd23f8c26': 'middle',
  'd2abd087': 'six',
  'd364b489': 'pansies',
  'd406998b': 'fireflies',
  'd43fd935': 'greenmagnet',
  'd4469b4b': 'rgbclassify',
  'd4a91cb9': 'hpwl2',
  'd4f3cd78': 'laminar',
  'd511f180': 'grayblueswap',
  'd5d6de2d': 'centersonly',
  'd631b094': 'flat',
  'd687bc17': 'colorclinger',
  'd6ad076f': 'bridge',
  'd89b689b': 'absorb',
  'd8c310e9': 'cityskyline',
  'd90796e8': 'drmario',
  'd9f24cd1': 'bumpandrun',
  'd9fac9be': 'centercell',
  'dae9d2b5': 'mergenta',
  'db3e9e38': 'pennant',
  'db93a21d': 'deathstars',
  'dbc1a6ce': 'connectdots',
  'dc0a314f': 'greencutout',
  'dc1df850': 'bluehalo',
  'dc433765': 'creeper',
  'ddf7fa4f': 'colorfill',
  'de1cd16c': 'mostestcolor',
  'ded97339': 'skyconnect',
  'e179c5f4': 'skybounce',
  'e21d9049': 'rainbowroads',
  'e26a3af2': 'denoise',
  'e3497940': 'foldandmerge',
  'e40b9e2f': 'pinwheel3',
  'e48d4e1a': 'diagonally',
  'e5062a87': 'spritegaps',
  'e509e548': 'elyouoraitch',
  'e50d258f': 'themostreds',
  'e6721834': 'compositing',
  'e73095fd': 'squarenet',
  'e76a88a6': 'copypaste3',
  'e8593010': 'onetwothree',
  'e8dc4411': 'continuation',
  'e9614598': 'farmacia',
  'e98196ab': 'blend',
  'e9afcf9a': 'twist',
  'ea32f347': 'threebears',
  'ea786f4a': 'x',
  'eb281b96': 'stretch',
  'eb5a1d5d': 'matryoshka',
  'ec883f72': 'antennaman',
  'ecdecbb3': 'projection',
  'ed36ccf7': 'rotate2',
  'ef135b50': 'redcarpet',
  'f15e1fac': 'shove',
  'f1cefba8': 'rebar',
  'f25fbde4': 'yellowsub',
  'f25ffba3': 'vflip',
  'f2829549': 'voids3',
  'f35d900a': 'fourcorners',
  'f5b8619d': 'tessellate',
  'f76d97a5': 'invert',
  'f8a8fe49': 'disassemble',
  'f8b3ba0a': 'dashboard',
  'f8c80d96': 'multimat',
  'f8ff0b80': 'descending',
  'f9012d9b': 'missingpiece',
  'fafffa47': 'voids4',
  'fcb5c309': 'containsmost',
  'fcc82909': 'greenshadow',
  'feca6190': 'soar',
  'ff28f65a': 'numboxes',
  'ff805c23': 'cutoutoscope',
};

/**
 * Get the friendly name for a puzzle ID.
 * Returns the name if found, otherwise returns undefined.
 * 
 * @param puzzleId - The puzzle ID to look up
 * @returns The friendly name or undefined if not found
 */
export function getPuzzleName(puzzleId: string): string | undefined {
  return PUZZLE_NAMES[puzzleId];
}

/**
 * Get a formatted display string combining puzzle ID and name.
 * Format: "ID - Name" or just "ID" if name not found.
 * 
 * @param puzzleId - The puzzle ID
 * @returns Formatted string for display
 */
export function formatPuzzleDisplay(puzzleId: string): string {
  const name = getPuzzleName(puzzleId);
  return name ? `${puzzleId} - ${name}` : puzzleId;
}

/**
 * Check if a puzzle ID has a registered name.
 * 
 * @param puzzleId - The puzzle ID to check
 * @returns True if the puzzle has a name, false otherwise
 */
export function hasPuzzleName(puzzleId: string): boolean {
  return puzzleId in PUZZLE_NAMES;
}
